import React from 'react'

const RegisterPaperSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 11.996 14.662'
    >
      <path
        id='document-svgrepo-com_1_'
        data-name='document-svgrepo-com (1)'
        d='M7.194,1.2A.666.666,0,0,1,7.665,1H13a2,2,0,0,1,2,2V13.663a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2v-8a.666.666,0,0,1,.2-.471ZM13,2.333H8.332V5.665a.666.666,0,0,1-.666.666H4.333v7.331A.666.666,0,0,0,5,14.329h8a.666.666,0,0,0,.666-.666V3A.666.666,0,0,0,13,2.333ZM5.275,5H7V3.275Zm.39,4a.666.666,0,0,1,.666-.666h5.332a.666.666,0,0,1,0,1.333H6.332A.666.666,0,0,1,5.666,9Zm0,2.666A.666.666,0,0,1,6.332,11h5.332a.666.666,0,0,1,0,1.333H6.332A.666.666,0,0,1,5.666,11.663Z'
        transform='translate(-3 -1)'
        fill='#fff'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default RegisterPaperSvg
